import React, { useContext, useState } from "react";
import { LocalizationContext } from "../../../../../../locales/Translation";
import {
  TAB_DAY_OFFICES_INDEX,
  TAB_DESK_BOOKINGS_INDEX,
  TAB_DESK_USAGE_INDEX,
  TAB_PRIVATE_OFFICES_INDEX,
  TAB_ROOM_BOOKINGS_INDEX,
} from "../../../../configs/Constants";
import Search from "../../../Dashboard/UsageList/components/Search";
import ButtonCustom from "../../../../../../components/Button";
import classNames from "classnames";
import FilterDeskUsage from "./components/DeskUsage/FilterDeskUsage";
import FilterDeskBooking from "./components/DeskBooking/FilterDeskBooking";
import FilterRoomBooking from "./components/RoomBooking/FilterRoomBooking";
import TableDeskUsage from "./components/DeskUsage/TableDeskUsage";
import TableDeskBookings from "./components/DeskBooking/TableDeskBookings";
import TableRoomBookings from "./components/RoomBooking/TableRoomBookings";
import FilterPrivateOffice from "../../../Dashboard/OfficeLeases/Filter";
import OfficeLeases from "../../../Dashboard/OfficeLeases";
import FilterDayOffice from "./components/DayOfficeBooking/FilterDayOfficeBooking";
import TableDayOfficeBookings from "./components/DayOfficeBooking/TableDayOfficeBookings";

const UsageList = () => {
  const { translations } = useContext(LocalizationContext);
  const [tabIndex, setTabIndex] = useState(TAB_DESK_USAGE_INDEX);
  const _onChangeTab = (value: number) => {
    setTabIndex(value);
  };

  return (
    <>
      <div className={"filter-section"}>
        <Search isDeskimoAdmin />
        <div className={"button-group yellow"}>
          <ButtonCustom
            height={"36px"}
            className={classNames({
              active: tabIndex === TAB_DESK_USAGE_INDEX,
            })}
            onClick={() => _onChangeTab(TAB_DESK_USAGE_INDEX)}
          >
            {translations.deskWalkIn}
          </ButtonCustom>
          <ButtonCustom
            height={"36px"}
            className={classNames({
              active: tabIndex === TAB_DESK_BOOKINGS_INDEX,
            })}
            onClick={() => _onChangeTab(TAB_DESK_BOOKINGS_INDEX)}
          >
            {translations.deskBookings}
          </ButtonCustom>
          <ButtonCustom
            height={"36px"}
            className={classNames({
              active: tabIndex === TAB_ROOM_BOOKINGS_INDEX,
            })}
            onClick={() => _onChangeTab(TAB_ROOM_BOOKINGS_INDEX)}
          >
            {translations.roomBookings}
          </ButtonCustom>
          <ButtonCustom
            height={"36px"}
            className={classNames({
              active: tabIndex === TAB_DAY_OFFICES_INDEX,
            })}
            onClick={() => _onChangeTab(TAB_DAY_OFFICES_INDEX)}
          >
            Day Offices
          </ButtonCustom>
          <ButtonCustom
            height={"36px"}
            className={classNames({
              active: tabIndex === TAB_PRIVATE_OFFICES_INDEX,
            })}
            onClick={() => _onChangeTab(TAB_PRIVATE_OFFICES_INDEX)}
          >
            Office Leases
          </ButtonCustom>
        </div>

        {tabIndex === TAB_DESK_USAGE_INDEX ? (
          <FilterDeskUsage />
        ) : tabIndex === TAB_DESK_BOOKINGS_INDEX ? (
          <FilterDeskBooking />
        ) : tabIndex === TAB_ROOM_BOOKINGS_INDEX ? (
          <FilterRoomBooking />
        ) : tabIndex === TAB_DAY_OFFICES_INDEX ? (
          <FilterDayOffice />
        ) : (
          <FilterPrivateOffice />
        )}
      </div>

      <div className={"dashboard_table"}>
        {tabIndex === TAB_DESK_USAGE_INDEX ? (
          <TableDeskUsage />
        ) : tabIndex === TAB_DESK_BOOKINGS_INDEX ? (
          <TableDeskBookings />
        ) : tabIndex === TAB_ROOM_BOOKINGS_INDEX ? (
          <TableRoomBookings />
        ) : tabIndex === TAB_DAY_OFFICES_INDEX ? (
          <TableDayOfficeBookings />
        ) : (
          <OfficeLeases />
        )}
      </div>
    </>
  );
};

export default UsageList;
